<template>
    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
        <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
            <div class="account-box">
                <div :class="{loader:!showSpinnerCreditCart}" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                    <img style="position:absolute;top:35%;left:40%;z-index:100" src="/assets/img/loader/loader.svg" />
                </div>
                <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                    <li v-for="error in errors.all()">{{ error }}</li>
                </ul>
                <div class="account-box-content">
                    <form @submit.prevent="" class="form-account">
                        <div class="form-account-title">اطلاعات کارت بانکی</div>  
                        <div class="form-account-row">
                            <label class="input-label"><i class="now-ui-icons shopping_credit-card"></i></label>
                            <input class="input-field" type="text" v-model="creditCartInfo.AccountKey" readonly="readonly" placeholder="شماره کارت مقصد">  
                        </div>
                        <div class="form-account-row">
                            <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                            <input class="input-field" type="text" readonly="readonly" v-model="creditCartInfo.AccountOwner" placeholder="بنام">  
                        </div>
                        <div class="form-account-row">
                            <label class="input-label"><i class="now-ui-icons objects_key-25"></i></label>
                            <input class="input-field" type="text" v-model="creditCartInfo.TrackingNo" v-validate="{required:true,max:1000}" data-vv-as="شماره تراکنش" placeholder="شماره تراکنش">  
                        </div>
                  

                        <div class="">
                            <div class="row">
                                <div class="col-md">
                                    <div class="form-account-row">
                                        <label class="input-label">
                                            <i class="fa fa-money" aria-hidden="true"></i>
                                        </label>
                                        <input class="input-field" type="text" v-model="creditCartInfo.Amount" v-validate="{required:true,numeric:true,min:3,max:10}" data-vv-as="مبلغ" placeholder="مبلغ">  
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-account-row">
                                        <label class="input-label cartLastNoLbl"><i class="fa fa-credit-card-alt"></i></label>
                                        <input class="input-field" v-model="creditCartInfo.CartLastNo" type="text" v-validate="{required:true,numeric:true,length:4}" data-vv-as="4 رقم شماره آخر کارت" placeholder="4 رقم  آخر کارت">  
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="">
                            <div class="row">

                                <div class="col-md">
                                    <div class="form-account-row">
                                        <label class="input-label">
                                            <i class="fa fa-exchange" aria-hidden="true"></i>
                                        </label>
                                        <input class="input-field" type="text" v-model="creditCartInfo.CurrencyType" v-validate="{required:true,max:30}" data-vv-as="نوع پرداختی" placeholder="نوع پرداختی"> <!--نوع پرداختی-->
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-account-row">
                                        <label class="input-label">
                                            <i class="fa fa-calendar" aria-hidden="true"></i>
                                        </label>
                                        <input class="input-field" type="text" v-model="creditCartInfo.PaymentDateTime" v-validate="{required:true,date_format:'yyyy/MM/dd'}" data-vv-as="تاریخ" placeholder="yyyy/MM/dd"> <!--تاریخ-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-account-row">
                            <textarea v-model="creditCartInfo.Comment" v-validate="{max:300}" data-vv-as="توضیحات" class="input-field comment-text aaaa" type="multipy" placeholder="توضیحات"></textarea> <!--توضیحات-->
                        </div>
                        <div class="form-account-row form-account-submit">
                            <div class="parent-btn">
                                <button @click="AddCreditCart" class="dk-btn dk-btn-info" type="submit">
                                      ثبت
                                    <i class="now-ui-icons arrows-1_share-66"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default {
        data() {
            return {
                showSpinnerCreditCart: false, creditCartInfo: { AccountKey: '', AccountOwner: '' },
            }
        },
        beforeMount: function () {
            this.isShowSppiner = true;
            httpPromise(this, '/v1/BasicDefinitions/Accounts/FindCreditCartAccount', 'get', '',
                response => {
                    toastr.remove();
                    this.creditCartInfo.AccountKey = response.data.Value.AccountKey;
                    this.creditCartInfo.AccountOwner = response.data.Value.AccountOwner;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);

                });
        },
        methods: {
            resetForm() {
                this.creditCartInfo.Amount = '';
                this.creditCartInfo.Comment = '';
                this.creditCartInfo.PaymentDateTime = '';
                this.creditCartInfo.CartLastNo = '';
                this.creditCartInfo.CurrencyType = '';
                this.creditCartInfo.TrackingNo = '';
            },
            //==========================================================
            AddCreditCart() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.showSpinnerCreditCart = true;
                        httpPromise(this, '/v1/Orders/PendingPayments/AddCreditCart', 'Post', JSON.stringify(this.creditCartInfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                this.showSpinnerCreditCart = false;
                                this.resetForm();
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.showSpinnerCreditCart = false;
                                this.resetForm();
                            });
                    }
                });
            },
            //==========================================================
        }
    }
</script>

<style scoped>
    .account-box-content {
        padding: 0 14px;
    }
    .comment-text {
        padding: 11px 11px 11px 15px;
    }
</style>